import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useDashboard } from 'hooks/useDashboard';
import Container from 'components/Container';
import Page from 'layout/Page';

import LayoutHandler from 'layout/dashboard-layouts/LayoutHandler';
import { calculateLayoutSlotsFromId } from 'utils/widget-helpers';
import Popups from './Popups/Popups';
import useSaveRecentDashboard from 'hooks/useSaveRecentDashboard/useSaveRecentDashboard';

const Dashboard = () => {
  const { id } = useParams();

  const [state, dashboardState, dispatchDashboard] = useDashboard(id);
  const { isLoading } = state;
  const { dashboardData, widgets, createDashboardData } = dashboardState;
  useSaveRecentDashboard(dashboardData);

  const [which, setWhichPopup] = useState();
  const [isEditMode, setIsEditMode] = useState(false);
  const [panelIndex, setPanelIndex] = useState();
  const [baseId, setBaseId] = useState();
  const [baseWidgetPlaceHolder, setBaseWidgetPlaceholder] = useState();
  const [baseWidgetWidth, setBaseWidgetWidth] = useState(4);
  const location = useLocation();

  const handleBaseWidgetClick = (baseWidgetId, baseWidgetImg) => {
    setBaseId(baseWidgetId);
    setBaseWidgetPlaceholder(baseWidgetImg);
    setWhichPopup('widget_create');
  };
  const { state: locationState } = location;

  const { isDashboardCreation, wasDashboardCreated } = !!locationState && locationState;

  useEffect(() => {
    if (!id && isDashboardCreation) setWhichPopup('dashboard_create');
    if (id && isDashboardCreation) setWhichPopup();
    if (id && wasDashboardCreated) setIsEditMode(true);
  }, [id, isDashboardCreation, wasDashboardCreated]);

  return (
    <Page
      isUserDashboard
      title={dashboardData && dashboardData.name}
      dashboardData={dashboardData}
      dashboardId={id}
      setIsEditMode={setIsEditMode}
      isEditMode={isEditMode}
      setWhichPopup={setWhichPopup}
    >
      <Container center maxWidth="xl">
        {widgets && widgets.length >= 0 && (
          <LayoutHandler
            layoutId={dashboardData.layout.id}
            widgets={widgets}
            updateWidget={dispatchDashboard}
            isDashboardLoading={isLoading}
            dashboardData={dashboardData}
            isEditMode={isEditMode}
            baseWidgetPlaceHolder={baseWidgetPlaceHolder}
            setWhichPopup={setWhichPopup}
            setPanelIndex={setPanelIndex}
            panelIndex={panelIndex}
            availableSlots={calculateLayoutSlotsFromId(dashboardData.layout.id)}
          />
        )}

        <Popups
          which={which}
          dashboardData={which === 'dashboard_create' ? createDashboardData : dashboardData}
          dispatchDashboard={dispatchDashboard}
          baseWidgetId={baseId}
          baseWidgetWidth={baseWidgetWidth}
          setBaseWidgetWidth={setBaseWidgetWidth}
          setWhichPopup={setWhichPopup}
          handleBaseWidgetClick={handleBaseWidgetClick}
          setBaseWidgetPlaceholder={setBaseWidgetPlaceholder}
          panelIndex={panelIndex}
        />
      </Container>
    </Page>
  );
};

export default Dashboard;
